import { render, staticRenderFns } from "./FloorPlansSection.vue?vue&type=template&id=38ff3548&"
import script from "./FloorPlansSection.vue?vue&type=script&lang=js&"
export * from "./FloorPlansSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ff3548')) {
      api.createRecord('38ff3548', component.options)
    } else {
      api.reload('38ff3548', component.options)
    }
    module.hot.accept("./FloorPlansSection.vue?vue&type=template&id=38ff3548&", function () {
      api.rerender('38ff3548', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/realEstate/sections/FloorPlansSection.vue"
export default component.exports